export const ownerInfo = [
    {
        label: "Please provide your email address?",
        fieldType: "text",
        fieldName: "Email",
        options: []
    },
    {
        label: "What's your full name?",
        fieldType: "text",
        fieldName: "Name",
        options: []
    },
    {
        label: "Enter your Kit ID?",
        fieldType: "number",
        fieldName: "Kit_id",
        options: []
    },
    // {
    //     label: "Enter the second Kit ID (14-digit number under the barcode):",
    //     fieldType: "number",
    //     fieldName: "KitID2",
    //     options: []
    // },
]
export const surveyForm = [

    {
        label: "Upload an image of your dog",
        fieldType: "file",
        fieldName: "imgBlob",
        options: []
    },
    {
        label: "What’s your dog’s name?",
        fieldType: "text",
        fieldName: "PetName",
        options: []
    },
    {
        label: "Is your dog male or female?",
        fieldType: "radio",
        fieldName: "Gender",
        options: ['Male', 'Female']
    },
    {
        label: "When is your dog’s birthday? (If unknown, please provide your best guess)",
        fieldType: "date",
        fieldName: "Birthday",
        options: []
    },
    {
        label: "What is your dog’s breed? (If mixed breed, list the top two breeds or your best estimate)",
        fieldType: "multiselect",
        fieldName: "BreedType",
        options: [
            "Affenpinscher",
            "Afghan Hound",
            "Airedale Terrier",
            "Akita",
            "Alaskan Malamute",
            "American Bulldog",
            "American English Coonhound",
            "American Eskimo Dog - Miniature",
            "American Eskimo Dog - Standard",
            "American Eskimo Dog - Toy",
            "American Foxhound",
            "American Hairless Terrier",
            "American Leopard Hound",
            "American Pit Bull Terrier",
            "American Staffordshire Terrier",
            "American Water Spaniel",
            "Anatolian Shepherd Dog",
            "Appenzeller Sennenhund",
            "Australian Cattle Dog",
            "Australian Kelpie",
            "Australian Shepherd",
            "Australian Stumpy Tail Cattle Dog",
            "Australian Terrier",
            "Azawakh",
            "Barbet",
            "Basenji",
            "Basset Fauve De Bretagne",
            "Basset Hound",
            "Bavarian Mountain Scent Hound",
            "Beagle",
            "Bearded Collie",
            "Beauceron",
            "Bedlington Terrier",
            "Belgian Laekenois",
            "Belgian Malinois",
            "Belgian Sheepdog",
            "Belgian Tervuren",
            "Bergamasco Sheepdog",
            "Berger Picard",
            "Bernese Mountain Dog",
            "Bichon Frise",
            "Biewer Terrier",
            "Black And Tan Coonhound",
            "Black Russian Terrier",
            "Bloodhound",
            "Bluetick Coonhound",
            "Boerboel",
            "Bohemian Shepherd",
            "Border Collie",
            "Border Terrier",
            "Borzoi",
            "Boston Terrier",
            "Bouvier Des Flandres",
            "Boxer",
            "Boykin Spaniel",
            "Bracco Italiano",
            "Braque Du Bourbonnais",
            "Braque Francais Pyrenean",
            "Briard",
            "Brittany Spaniel",
            "Broholmer",
            "Brussels Griffon",
            "Bull Terrier",
            "Bulldog",
            "Bullmastiff",
            "Cairn Terrier",
            "Canaan Dog",
            "Cane Corso",
            "Cardigan Welsh Corgi",
            "Carolina Dog",
            "Catahoula Leopard Dog",
            "Caucasian Shepherd Dog",
            "Cavalier King Charles Spaniel",
            "Central Asian Shepherd Dog",
            "Cesky Terrier",
            "Chesapeake Bay Retriever",
            "Chihuahua",
            "Chinese Crested",
            "Chinese Shar-Pei",
            "Chinook",
            "Chow Chow",
            "Cirneco Dell Etna",
            "Clumber Spaniel",
            "Cocker Spaniel",
            "Collie",
            "Coton De Tulear",
            "Croatian Sheepdog",
            "Curly-Coated Retriever",
            "Czechoslovakian Vlcak",
            "Dachshund - Medium",
            "Dachshund - Toy",
            "Dalmatian",
            "Dandie Dinmont Terrier",
            "Danish-Swedish Farmdog",
            "Deutscher Wachtelhund",
            "Doberman Pinscher",
            "Dogo Argentino",
            "Dogue De Bordeaux",
            "Drentsche Patrijshond",
            "Drever",
            "Dutch Shepherd",
            "English Cocker Spaniel",
            "English Foxhound",
            "English Setter",
            "English Springer Spaniel",
            "English Toy Spaniel",
            "Entlebucher Mountain Dog",
            "Estrela Mountain Dog",
            "Eurasier",
            "Field Spaniel",
            "Finnish Lapphund",
            "Finnish Spitz",
            "Flat-Coated Retriever",
            "French Bulldog",
            "French Spaniel",
            "German Longhaired Pointer",
            "German Pinscher",
            "German Shepherd Dog",
            "German Shorthaired Pointer",
            "German Spitz",
            "German Wirehaired Pointer",
            "Giant Schnauzer",
            "Glen Of Imaal Terrier",
            "Golden Retriever",
            "Gordon Setter",
            "Grand Basset Griffon Vendeen",
            "Great Dane",
            "Great Pyrenees",
            "Greater Swiss Mountain Dog",
            "Greyhound",
            "Hamiltonstovare",
            "Hanoverian Scenthound",
            "Harrier",
            "Havanese",
            "Hokkaido",
            "Hovawart",
            "Ibizan Hound",
            "Icelandic Sheepdog",
            "Irish Red And White Setter",
            "Irish Setter",
            "Irish Terrier",
            "Irish Water Spaniel",
            "Irish Wolfhound",
            "Italian Greyhound",
            "Jagdterrier",
            "Japanese Chin",
            "Japanese Spitz",
            "Jindo",
            "Kai Ken",
            "Karelian Bear Dog",
            "Keeshond",
            "Kerry Blue Terrier",
            "Kishu Ken",
            "Komondor",
            "Kromfohrlander",
            "Kuvasz",
            "Labrador Retriever",
            "Lagotto Romagnolo",
            "Lakeland Terrier",
            "Lancashire Heeler",
            "Lapponian Herder",
            "Leonberger",
            "Lhasa Apso",
            "Lowchen",
            "Maltese",
            "Manchester Terrier - Small",
            "Manchester Terrier - Toy",
            "Mastiff",
            "Miniature American Shepherd",
            "Miniature Bull Terrier",
            "Miniature Pinscher",
            "Miniature Schnauzer",
            "Mountain Cur",
            "Neapolitan Mastiff",
            "Nederlandse Kooikerhondje",
            "Newfoundland",
            "Norfolk Terrier",
            "Norrbottenspets",
            "Norwegian Buhund",
            "Norwegian Elkhound",
            "Norwegian Lundehund",
            "Norwich Terrier",
            "Nova Scotia Duck Tolling Retriever",
            "Old English Sheepdog",
            "Otterhound",
            "Papillon",
            "Parson Russell Terrier",
            "Pekingese",
            "Pembroke Welsh Corgi",
            "Perro De Presa Vendeen",
            "Peruvian Inca Orchid - Large",
            "Peruvian Inca Orchid - Medium",
            "Peruvian Inca Orchid - Small",
            "Petit Basset Griffon Vendeen",
            "Pharaoh Hound",
            "Plott",
            "Pointer",
            "Polish Lowland Sheepdog",
            "Pomeranian",
            "Poodle - Miniature",
            "Poodle - Standard",
            "Poodle - Toy",
            "Porcelaine",
            "Portuguese Podengo - Large",
            "Portuguese Podengo - Medium",
            "Portuguese Podengo Pequeno",
            "Portuguese Pointer",
            "Portuguese Sheepdog",
            "Portuguese Water Dog",
            "Pudelpointer",
            "Pug",
            "Puli",
            "Pumi",
            "Pyrenean Mastiff",
            "Pyrenean Shepherd",
            "Rafeiro Do Alentejo",
            "Rat Terrier",
            "Redbone Coonhound",
            "Rhodesian Ridgeback",
            "Romanian Mioritic Shepherd Dog",
            "Rottweiler",
            "Russell Terrier",
            "Russian Toy",
            "Russian Tsvetnaya Bolonka",
            "Saint Bernard",
            "Saluki",
            "Samoyed",
            "Schapendoes",
            "Schipperke",
            "Scottish Deerhound",
            "Scottish Terrier",
            "Sealyham Terrier",
            "Segugio Italiano",
            "Shetland Sheepdog",
            "Shiba Inu",
            "Shih Tzu",
            "Shikoku",
            "Siberian Husky",
            "Silky Terrier",
            "Skye Terrier",
            "Sloughi",
            "Slovakian Wirehaired Pointer",
            "Slovensky Cuvac",
            "Slovensky Kopov",
            "Smooth Fox Terrier",
            "Soft Coated Wheaten Terrier",
            "Spanish Mastiff",
            "Spanish Water Dog",
            "Spinone Italiano",
            "Stabyhoun",
            "Staffordshire Bull Terrier",
            "Standard Schnauzer",
            "Sussex Spaniel",
            "Swedish Lapphund",
            "Swedish Vallhund",
            "Taiwan Dog",
            "Teddy Roosevelt Terrier",
            "Thai Ridgeback",
            "Tibetan Mastiff",
            "Tibetan Spaniel",
            "Tibetan Terrier",
            "Tornjak",
            "Tosa",
            "Toy Fox Terrier",
            "Transylvanian Hound",
            "Treeing Tennessee Brindle",
            "Treeing Walker Coonhound",
            "Unknown",
            "Vizsla",
            "Weimaraner",
            "Welsh Springer Spaniel",
            "Welsh Terrier",
            "West Highland White Terrier",
            "Wetterhoun",
            "Whippet",
            "Wire Fox Terrier",
            "Wirehaired Pointing Griffon",
            "Wirehaired Vizsla",
            "Working Kelpie",
            "Xoloitzcuintli - Miniature",
            "Xoloitzcuintli - Standard",
            "Xoloitzcuintli - Toy",
            "Yakutian Laika",
            "Yorkshire Terrier"
        ]
    },
    {
        label: " How would you describe your dog's size?(Small, Medium, Large)",
        fieldType: "select",
        fieldName: "BreedSize",
        options: [
            "Small (6-25 lbs)",
            "Medium (25-55 lbs)",
            "Large (55-70 lbs)",
            "Giant (>70 lbs)",]
    },
]
export const healthWellbeing = [
    // {
    //     label: "Would you like us to share a detailed health report with your veterinarian?",
    //     fieldType: "radio",
    //     fieldName: "ReportToVet",
    //     options: ['Yes', 'No']
    // },
    {
        label: "Does your dog experience soft stool, especially during stressful times?",
        fieldType: "radio",
        fieldName: "SoftStool",
        options: ['Yes', 'No']
    },
    {
        label: "Does your dog often have small, hard stools?",
        fieldType: "radio",
        fieldName: "SmallandHardStool",
        options: ['Yes', 'No']
    },
    {
        label: "Do you have any concerns about your dog’s digestive health?",
        fieldType: "radio",
        fieldName: "DigestiveHealthConcerns",
        options: ['Yes', 'No']
    },
    {
        label: "Does your dog have a dry coat or dry skin?",
        fieldType: "radio",
        fieldName: "DryCoatOrSkin",
        options: ['Yes', 'No']
    },
    {
        label: "Would you like to help your dog have a healthy immune system?",
        fieldType: "radio",
        fieldName: "LikeToHaveHealthyImmuneSystem",
        options: ['Yes', 'No']
    },
    {
        label: "Has your dog been diagnosed with any of the following medical conditions?",
        fieldType: "multiselect",
        fieldName: "HasMedicalConditions",
        options: [
            "Allergies",
            "Skin bacterial infections",
            "Autoimmune disease",
            "Prone to oxalate urinary crystals",
            "Fatty tumors",
            "Skin cysts",
            "Ear infections",
            "Cloudy eyes",
            "Cataracts",
            "Hearing loss",
            "Early dental disease",
            "Digestive issues",
            "Inflammatory Bowel Disease",
            "Struvites",
            "Proteinuria",
            "Recurring urinary tract infections",
            "Urinary incontinence",
            "Seizures",
            "Mild periodic seizures",
            "Epilepsy",
            "Anxiety",
            "Cognitive issues",
            "Arthritis",
            "Hip dysplasia",
            "Torn knee ligaments",
            "Luxating patellas",
            "Heart murmur",
            "Slight heart murmur",
            "Heart disease",
            "Increased liver enzymes",
            "High liver values",
            "Liver issues",
            "Diabetes",
            "Primary Ciliary Dyskinesia",
            "Bronchitis",
            "Cancer",
            "Anal gland issues",
            "No medical conditions"
        ]
    },
    {
        label: "Has your dog ever been diagnosed with urinary stones?",
        fieldType: "multiselect",
        fieldName: "HasUrinaryMedicalConditions",
        options: ['Calcium Oxalate', 'Struvite', "Urate (Uric Acid)", "Cystine", "I don't know"]

    },
]
export const nutritionDiet = [

    {
        label: "What types of food do you usually feed your dog?",
        fieldType: "multiselect",
        fieldName: "FoodType",
        options: [
            "Dry",
            "Wet",
            "Raw",
            "Home-made",
            "Refrigerated"
        ]
    },
    {
        label: "What’s your dog’s favorite source of protein?",
        fieldType: "multiselect",
        fieldName: "FavProteinSource",
        options: ["Chicken", "Beef", "Fish", "Lamb", "Turkey", "Egg", "Vegetables", "No Preference",]
    },
    {
        label: "Are there any special ingredients you look for in your dog’s food?",
        fieldType: "multiselect",
        fieldName: "SpecialIngredients",
        options: [
            "Epa and DHA",
            "Probiotics",
            "Fish oil",
            "Taurine",
            "Glucosamine",
            "Antioxidants",
            "Biotin",
            "Chamomile",
            "Prebiotics",
            "MCT (coconut oil)", "None of the above",
        ]
    },
    {
        label: "Does your dog have any known food allergies or ingredients you avoid?",
        fieldType: "multiselect",
        fieldName: "AllergicIngredients",
        options: ["Grain (corn, soy, wheat)",
            "Legumes",
            "Artificial colors",
            "Preservatives", "None of the above",]
    },
    {
        label: "How often do you feed your dog each day?",
        fieldType: "select",
        fieldName: "NoOfFeedsPerDay",
        options: ["Free access all day",
            "Once",
            "Three times",
            "Twice"]
    },
    {
        label: "Is your dog currently on any supplements?",
        fieldType: "multiselect",
        fieldName: "ConsumingSupplements",
        options: [
            "Gabapentin",
            "Apoquel",
            "Dosaquin",
            "Galliprant",
            "Fortiflora",
            "Vetprofen",
            "Even Root - Digestion",
            "Nexgard",
            "Interceptor Plus",
            "Proheart",
            "Glucosamine",
            "Calming care",
            "Probiotic",
            "Everroot Immunity",
            "Paroxitene",
            "Traz",
            "Calming Care",
            "Prazac",
            "Hydracodane",
            "Doxycyclide",
            "Other"
        ]

    },
    {
        label: "Are you looking to replace this supplement?",
        fieldType: "radio",
        fieldName: "SupplementReplacement",
        options: ['Yes', 'No']
    },
]
export const healthGoals = [
    {
        label: "What are your primary health goals for your dog?",
        fieldType: "multiselect",
        fieldName: "HealthGoals",
        options: [
            "Anxiety",
            "Digestive Health",
            "Skin & Coat",
            "Long Quality of Life",
            "Dental Health",
            "Brain Development",
            "Heart Health",
            "Joint Mobility",
            "Weight Loss",
            "Ear Infection",
            "Urinary Tract Health",
            "Vision",
            "Improve Appetite",
            "Increased Energy",
            "Mental Cognition",
            "No Health Goal",
            "Other"
        ]
    },
    {
        label: "If you have more than one health goal, please rank your top three priorities for your dog’s health.",
        fieldType: "multiselect",
        fieldName: "TopThreeHealthGoals",
        options: []
    },
    {
        label: "What is your dog's current weight (in pounds)?",
        fieldType: "number",
        fieldName: "PetWeightInPounds",
        options: []
    },
    {
        label: "How would you describe your dog’s body condition? (e.g., underweight, ideal, overweight)",
        fieldType: "select",
        fieldName: "BodyCondition",
        options: [
            "Ideal Weight (Visible waist and abdominal tuck)",
            "Overweight (Absent waist, ribs difficult to see)",
            "Underweight (No visible fat, bony look)"
        ]
    },
    {
        label: "Over the past year, how would you describe your dog’s overall health and physical condition?",
        fieldType: "select",
        fieldName: "OverThePastYear",
        options: [
            "Gaining weight",
            "Losing weight",
            "Maintaining weight"
        ]
    },
    {
        label: "If your dog has lost weight, was it part of an intentional feeding or exercise plan?",
        fieldType: "radio",
        fieldName: "IsWeightLossDueToIntentionalFeeding",
        options: ['Yes', 'No']
    },
    {
        label: "If your dog has gained weight, was it the result of a specific feeding regimen?",
        fieldType: "radio",
        fieldName: "IsWeightGainDueToIntentionalFeeding",
        options: ['Yes', 'No']
    },
]
export const behaviourLifestyle = [
    {
        label: "Are you concerned about your dog experiencing anxiety or stress?",
        fieldType: "radio",
        fieldName: "Anxietyconcern",
        options: ['Yes', 'No']
    },
    {
        label: "If yes, can you share more details about your concerns?",
        fieldType: "textarea",
        fieldName: "AnxietyDescription",
        options: []
    },
    {
        label: "How would you rate the condition of your dog's skin and coat? (e.g., shiny, dry, flaky)",
        fieldType: "select",
        fieldName: "SkinAndCoatRating",
        options: [
            "Excellent",
            "Good, but room for improvement",
            "Poor"
        ]
    },
    {
        label: "Does your dog have noticeable tear staining around the eyes?",
        fieldType: "radio",
        fieldName: "TearStaining",
        options: ['Yes', 'No']
    },
]
export const medicationSupplement = [
    {
        label: "Is your dog currently taking any probiotics, supplements, or medications, aside from flea, tick, or heartworm preventatives?",
        fieldType: "radio",
        fieldName: "PetMedications",
        options: ['Yes', 'No']
    },
    {
        label: "If yes, please list them out here.",
        fieldType: "text",
        fieldName: "PetMedicationNames",
        options: []
    },
]
export const personalityActivity = [
    {
        label: "How would you describe your dog’s personality?",
        fieldType: "multiselect",
        fieldName: "PetPersonality",
        options: [
            "A balanced mix of calm and energetic",
            "A mix of many traits",
            "Active most of the day but slower on rainy days",
            "Alert, protective, and vocal (barks frequently)",
            "All of the above, depending on the moment",
            "Alternates between high-energy and calm",
            "Always on the go",
            "Calm and relaxed",
            "Calm and shy/nervous",
            "Calm but active when needed",
            "Calm but alert to strangers",
            "Calm but can become anxious depending on the environment",
            "Calm but influenced by the energy of another dog",
            "Calm indoors, driven or hunting-focused outdoors",
            "Calm unless triggered by trucks or animals",
            "Combination of calm and always on the go",
            "Energetic but able to relax",
            "Energetic in short bursts",
            "Energetic in some situations, calm in others",
            "Friendly and excited but prone to anxiety",
            "Friendly, active, and protective",
            "Happy, excited, and playful",
            "Highly energetic and loyal",
            "Independent",
            "Mostly calm",
            "Mostly calm, but anxious in chaotic environments (e.g., around small children)",
            "Nervous and high-energy",
            "Nervous around other dogs",
            "Nervous in new situations but calm and loving at home",
            "Nervous, shy, but friendly",
            "Occasionally nervous",
            "Outgoing and confident",
            "Senior, relaxed, and low-energy",
            "Shy but energetic",
            "Shy or nervous",
            "Sometimes lazy, sometimes very energetic",
            "Varies greatly depending on the situation",
            "Very curious and constantly sniffing/exploring",
            "Very energetic"
        ]
    },
    {
        label: "Does your dog take their role as a guard dog too seriously, often barking at new people or other dogs?",
        fieldType: "radio",
        fieldName: "FrequentBarkingAtOthers",
        options: ['Yes', 'No']
    },
    {
        label: "Would you describe your dog as a “weekend warrior,” being more active on some days than others?",
        fieldType: "radio",
        fieldName: "WeekendWarrior",
        options: ['Yes', 'No']
    },

    {
        label: "Does your dog act or look their age? (Choose all that apply)",
        fieldType: "multiselect",
        fieldName: "PetAgeLook",
        options: ["Acts older",
            "Acts younger",
            "Looks older",
            "Looks younger"
        ]
    },
]
export const maleQuestionary = [
    {
        label: "Has your dog been neutered?",
        fieldType: "radio",
        fieldName: "PetNeutered",
        options: ['Yes', 'No']
    },
]
export const femaleQuestionary = [
    {
        label: "Has your dog been spayed?",
        fieldType: "radio",
        fieldName: "PetSpayed",
        options: ['Yes', 'No']
    },
    {
        label: "Has she ever been bred?",
        fieldType: "radio",
        fieldName: "BreedingActivity",
        options: ['Yes', 'No']
    },
    {
        label: "Is dog currently pregnant?",
        fieldType: "radio",
        fieldName: "IsPregnant",
        options: ['Yes', 'No']
    },
]
export const finalThoughts = [
    {
        label: "Is there anything else we should know about your dog?",
        fieldType: "textarea",
        fieldName: "OtherInfo",
        options: []
    },
]
export const Acknoledgement = [
    {
        label: "Yes, I agree to receive email and other marketing communications from Petivity, Purina, and its brands. I certify that I am 18 years of age or older and have read and agree to the Notice at Collection, Terms and Conditions, and Privacy Policy.",
        fieldType: "radio",
        fieldName: "IsAcknowledged",
        options: ['Yes']
    },
    {
        label: "I consent to Petivity using data derived from my dog’s DNA sample, collected through a cheek or mouth swab, in aggregated data with information from other participating pets to improve Petivity’s predictive algorithms, analyses, and services. This aggregated data will include information about my dog and will not include my personal information or information that directly identifies me. If I do not check this box, my dog’s data will not be included in this aggregated data.",
        fieldType: "radio",
        fieldName: "IsDnaAggregationConsented",
        options: ['Yes']
    },
]